module.exports = __webpack_public_path__ + "img/whatsnew-gradientmap_cn.07c25b8.jpg";